import { fetchJson2 } from 'helpers/api';

const fetchAlerts = () => {
  return fetchJson2('/api/ore/get_alerts?json=true');
};

export { fetchAlerts };
